export default class ContactRadioGroup {
    constructor() {
      this.valueInput = '';
      this.idEmail = 'contact-email';
      this.idPhone = 'contact-phone';
      this.idText = 'contact-text';
      this.radioInputSelector = '[name="preferredContactMethod"]';
      this.labelEmail = `<label for="${this.idEmail}">Email</label>`;
      this.labelPhone = `<label for="${this.idPhone}">Phone</label>`;
      this.labelText = `<label for="${this.idText}">Text</label>`;
    }

    set value(newValue){
      this.valueInput = newValue || '';
    }
  
    get value(){
      return this.valueInput;
    }
  
    getHtml() {
      return `<div class="field--radio">
        <input data-qa="email-radio" type="radio" id="${this.idEmail}" name="preferredContactMethod"
        ${this.value === "Email" ? "checked" : ""} value="Email" />
        ${this.labelEmail}
      </div>
      <div class="field--radio">
        <input data-qa="phone-radio" type="radio" id="${this.idPhone}" name="preferredContactMethod" 
        ${this.value === "Phone" ? "checked" : ""} value="Phone" />
        ${this.labelPhone}
      </div>
      <div class="field--radio">
        <input data-qa="message-radio" type="radio" id="${this.idText}" name="preferredContactMethod" 
        ${this.value === "Text Message" ? "checked" : ""} value="Text Message" />
        ${this.labelText}
      </div>`;
    }
    
    onChange(callback) {
      document.querySelectorAll(this.radioInputSelector).forEach((node) => node.addEventListener('change', callback));
    }
  }
  